import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Import Icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';

// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';
import Header from './components/Header';
import SideBar from './components/SideBar';
import Main from './components/Main';

const App = () => {
  const [selectedIndicateur, setSelectedIndicateur] = useState(null);
  const [indicateurInfo, setIndicateurInfo] = useState(null);
  const [valeurs, setValeurs] = useState([]);

  // Function to handle indicator selection
  const handleIndicateurSelect = (id) => {
    setSelectedIndicateur(id);
  };

  // Fetch indicator details and values
  useEffect(() => {
    if (selectedIndicateur) {
      // Fetch indicator details
      axios.get(`https://indicateurapi.stats.ci/indicateurs/${selectedIndicateur}`)
      //axios.get(`http://172.20.160.1:3000/indicateurs/${selectedIndicateur}`)
        .then(response => {
          setIndicateurInfo(response.data);
        })
        .catch(error => {
          console.error('Error fetching indicator details:', error);
        });

      // Fetch indicator values
      axios.get(`https://indicateurapi.stats.ci/valeurs/${selectedIndicateur}`)
      //axios.get(`http://172.20.160.1:3000/valeurs/${selectedIndicateur}`)
        .then(response => {
          setValeurs(response.data);
        })
        .catch(error => {
          console.error('Error fetching indicator values:', error);
        });
    }
  }, [selectedIndicateur]);

  // Initialiser Bootstrap pour les éléments collapse
  useEffect(() => {
    // Assurer que les scripts de Bootstrap sont bien initialisés
    const bootstrapScript = document.createElement('script');
    bootstrapScript.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js';
    bootstrapScript.integrity = 'sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p';
    bootstrapScript.crossOrigin = 'anonymous';
    document.body.appendChild(bootstrapScript);

    return () => {
      document.body.removeChild(bootstrapScript);
    };
  }, []);

  return (
    <Router>
      <Header />
      <SideBar onIndicateurSelect={handleIndicateurSelect} />
      <Main indicateurInfo={indicateurInfo} valeurs={valeurs} />
    </Router>
  );
};

export default App;
